import Cookies from 'js-cookie';
import type { Dispatch } from 'redux';

import { encryptData } from '../../../helpers/encryption';
import {
  restoreLocalStorageSnapshot,
  snapshotPersistentPromptKeys,
} from '../../../helpers/persistentLocalStorage';
import {
  calculateTokenRefreshTime,
  convertMilliSecondsToDays,
} from '../../../helpers/utilityFunctions';
import { IUserSignIn, IUserToken } from '../../../types/user';
import { setAccessTokenExpirationTime } from './accessTokenExpirationSlice';

interface IPersistAuthDataInput {
  user?: IUserSignIn;
  token?: IUserToken;
  email: string;
  dispatch: Dispatch;
}

export const persistAuthData = ({
  user,
  token,
  email,
  dispatch,
}: IPersistAuthDataInput) => {
  const expiresInMilliseconds = token?.expiresIn;
  const expiresInDays = convertMilliSecondsToDays(expiresInMilliseconds);

  const encryptedAuthData = encryptData({ user });

  Cookies.set('tokenData', JSON.stringify(token), {
    expires: expiresInDays,
    sameSite: 'Strict',
    secure: true,
  });

  const promptSnapshot = snapshotPersistentPromptKeys();
  localStorage.clear();
  restoreLocalStorageSnapshot(promptSnapshot);

  localStorage.setItem('otherAuthData', encryptedAuthData);
  localStorage.setItem('emailAddress', email.toLowerCase());
  localStorage.setItem('firstName', user?.firstName ?? '');

  if (user?.hasPin) {
    localStorage.setItem('userHasPin', 'true');
  }

  if (user?.businesses?.[0]?.hasAccount) {
    localStorage.setItem('userHasAccount', 'true');
  }

  if (user?.businesses?.[0]?.id) {
    localStorage.setItem('businessId', user.businesses[0].id);
  }

  if (user?.businesses?.[0]?.name) {
    localStorage.setItem('businessName', user.businesses[0].name);
  }

  if (user?.id) {
    localStorage.setItem('userId', user.id);
  }

  if (user?.onboardingMode === 'offline' && !user?.isPasswordChanged) {
    localStorage.setItem('newlyOnboarded', 'true');
  }

  dispatch(
    setAccessTokenExpirationTime(calculateTokenRefreshTime(expiresInMilliseconds)),
  );
};
